import React from "react";

const Skeleton = () => {
  return (
    <>
      <div className="skeleton"></div>
      <div className="skeleton"></div>
      <div className="skeleton"></div>
      <div className="skeleton"></div>
    </>
  );
};

export default Skeleton;
